@import '../../scss/mixin';

.upload {
  @include btn();

  &:has(.input:focus),
  &:has(.input:focus-visible) {
    outline-color: var(--llm-color-outline);
  }

  &:has(.input:hover) {
    outline-color: color-mix(in srgb, var(--llm-color-outline) 10%, transparent 90%);
  }

  &:has(.input:active) {
    outline-color: var(--llm-color-accent-foreground);
  }
}

.input {
  appearance: none;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: none;
  border: none;
  color: transparent;
  outline: none;
  font-size: 0;
  opacity: 0;
  cursor: pointer;
}

.ui {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: var(--llm-input-accent);
  outline: none;
  pointer-events: none;

  svg {
    width: 20px;
    height: 20px;
  }
}

.file {
  @include button();
  position: absolute;
  right: 0;
  bottom: 100%;
  display: flex;
  align-items: center;
  column-gap: 0.35em;
  padding: 0.2em 1em;
  margin-bottom: 0.3rem;
  font-size: 12px;
  background: var(--llm-pill-background);
  color: var(--llm-pill-foreground);
  border-radius: 8px;
  backdrop-filter: blur(20px);

  span {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: var(--llm-pill-font-family);
    font-weight: 700;
  }

  svg {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentColor;
  }

  img {
    display: none;
    position: absolute;
    max-width: 96px;
    max-height: 96px;
    bottom: 100%;
    right: 0;
    border-radius: 8px;
    margin-bottom: 0.3rem;
    box-shadow: shadow(xs);
    pointer-events: none;
    object-fit: contain;
  }

  &:hover {
    img {
      display: block;
    }
  }
}
